import jwt_decode from "jwt-decode";

export const isAuthenticated = () => localStorage.getItem("@Reservei:token") !== null;

export const getToken = () => localStorage.getItem("@Reservei:token");

export const isAdmin = () => {
  if (isAuthenticated()) {
    const token = jwt_decode(getToken());
    if (token.user.role === "admin") {
      return true;
    }
  }
  return false;
};

export const isEstablishment = () => {
  if (isAuthenticated()) {
    const token = jwt_decode(getToken());
    if (token.user.role === "establishment") {
      return true;
    }
  }
  return false;
};

export const decodeToken = () => {
  if (getToken()) return jwt_decode(localStorage.getItem("@Reservei:token"));
  return null;
};
